export default __webpack_public_path__ + "static/media/home-artist1.bfb03b52.jpg";